module.exports = __webpack_public_path__ + "img/loader.29c3bd5b.gif";